export const LIST_BOOK_ID = {
  REDACTION: 14,
};
